import React from 'react';
import classNames from 'classnames';
import styles from '../styles.module.css';

interface ToolbarButtonProps {
  active: boolean;
  locked: boolean;
  onMouseDown: React.MouseEventHandler<HTMLElement>;
  onClick: React.MouseEventHandler<HTMLElement>;
  onDoubleClick: React.MouseEventHandler<HTMLElement>;
  testId?: string;
  children: React.ReactNode;
  className?: string;
}

// Same looks as a ToolButton, just minus a ton of logic
const ToolbarButton: React.FC<ToolbarButtonProps> = ({
  active,
  children,
  locked,
  onClick,
  onDoubleClick,
  onMouseDown,
  testId,
  className,
}) => {
  return (
    <div
      className={classNames(styles.toolButton, className, {
        [styles.toolButtonActive]: active,
        [styles.toolButtonLocked]: locked,
      })}
      onMouseDown={onMouseDown}
      onClick={onClick}
      onDoubleClick={onDoubleClick}
      role='button'
      data-testid={testId}
    >
      {children}
    </div>
  );
};

export default ToolbarButton;
